module.exports = __webpack_public_path__ + "media/images/product_lines/car/h3-baaa39f60b0eb017c9589ef313951c5f.svg";